import { useState } from "react";
import { SearchDateSingleForm } from "src/components/common/form/search/SearchDateSingleForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { CompanyDto } from "src/dtos/company/companyDto";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { useEQM1011_R01Store } from "./Store_EQM1011_R01";

export const SearchSection_EQM1011_R01 = () => {
    const { EQM1011_R01Filter, setEQM1011_R01Filter } = useEQM1011_R01Store();
    const { compCdList, plcaddressList } = useCommonCodeStore();
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState({ top: 0, left: 0 });

    return (
        <SearchSectionForm>
            <SearchDropDownForm<CompanyDto>
                label="사업장"
                value={EQM1011_R01Filter.compCd}
                optionList={compCdList}
                onChangeValue={(value) => setEQM1011_R01Filter({
                    compCd: value === 'all' ? '' : value,
                })}
            />
            <SearchDateSingleForm
                label="조회일자"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                value={EQM1011_R01Filter.baseDate}
                onChange={(baseDate) => setEQM1011_R01Filter({ baseDate })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />
            <SearchDropDownForm<SysCodeDto>
                label="데이터종류"
                value={EQM1011_R01Filter.plcaddressid?.toString() || 'all'}
                optionList={plcaddressList}
                onChangeValue={(value) => setEQM1011_R01Filter({
                    plcaddressid: value === 'all' || value === '' ? null : Number(value),
                })}
                wrapperOption={{ selectStyle: 'w-[200px] min-w-[200px]' }}
            />
        </SearchSectionForm>
    );
};
